export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  category: string;
  category_id?: string;
  images: string[];
}
 
 export const categories = ["Todos", "Bastidores", "Necessaires", "Enxovais", "Decoração"];
 
export const products: Product[] = [
  {
    id: "1",
    name: "Bastidor Floral Personalizado",
    description: "Lindo bastidor bordado à mão com flores delicadas. Perfeito para decoração de maternidade ou presente especial.",
    price: 89.90,
    category: "Bastidores",
    images: ["https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?auto=format&fit=crop&q=80&w=400"]
  },
  {
    id: "2",
    name: "Necessaire Charmosa",
    description: "Necessaire em tecido estruturado com bordado personalizado. Espaçosa e ideal para organizar seus itens.",
    price: 45.00,
    category: "Necessaires",
    images: ["https://images.unsplash.com/photo-1590736704728-f4730bb3c3af?auto=format&fit=crop&q=80&w=400"]
  }
];
 
 export const WHATSAPP_NUMBER = "5511999999999";